import { lazy, Suspense } from "react";
import LoadingScreen from "../components/LoadingScreen";

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
(
    <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
    </Suspense>
);

// ----------------------------------------------------------------------

export const HomePage = Loadable(lazy(() => import("../pages/HomePage")));
export const MainLayout = Loadable(lazy(() => import("../layouts/main")));
export const Page404 = Loadable(lazy(() => import("../pages/Page404")));

